// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html

import {
  DefaultPage,
  Statistics,
  Graphs,
} from './';

export default {
  path: 'products',
  name: 'Products',
  childRoutes: [
    { path: 'default-page', name: 'Default page', component: DefaultPage, isIndex: true },
    { path: ':name', name: 'Statistics', component: Statistics },
    { path: ':name/:userId', name: 'Graphs', component: Graphs },
  ],
};



// WEBPACK FOOTER //
// ./src/features/products/route.js